import React, { useEffect, useState } from 'react';
import { FiArrowLeft, FiCheck, FiSave } from 'react-icons/fi';
import { ClipLoader } from 'react-spinners';
import '../customerMaster/customerForm.css';

// Add-form popup layout from add-customer.html: title + chips + Back/Save, numbered stepper, progress hint bar,
// scrolling body and a Previous / Next footer. Steps can be opened in any order; a step shows a check once visited
// (or when it has rows, via `count`). Styled by .cf-pop* / .cf-step* in customerMaster/customerForm.css.
//   steps: [{ key, label, count? }]   activeKey / onStep(key) control the open step.
const StepForm = ({
  title, chip, subtitle, steps, activeKey, onStep, onBack, onSave, saving, saveLabel = 'Add', children,
}) => {
  const [visited, setVisited] = useState(() => new Set([activeKey]));
  useEffect(() => { setVisited((v) => new Set(v).add(activeKey)); }, [activeKey]);
  const idx = Math.max(0, steps.findIndex((s) => s.key === activeKey));
  const isDone = (s) => (visited.has(s.key) && s.key !== activeKey) || (s.count || 0) > 0;
  const filled = steps.filter(isDone).length;

  return (
    <div className="cf-pop">
      <div className="cf-pop-head">
        <div className="cf-headtext">
          <div className="cf-titlerow">
            <h1>{title}</h1>
            {chip && <span className="cf-docno">{chip}</span>}
            <span className="cf-badge draft">Draft</span>
          </div>
          {subtitle && <p className="cf-lede">{subtitle}</p>}
        </div>
        <div className="cf-headbtns">
          <button type="button" className="cf-btn cf-btn-ghost" onClick={onBack}><FiArrowLeft size={16} />Back</button>
          <button type="button" className="cf-btn cf-btn-primary" onClick={onSave} disabled={saving === true}>
            {saving === true ? <ClipLoader color="#ffffff" size={16} /> : <FiSave size={16} />}{saveLabel}
          </button>
        </div>
      </div>

      <div className="cf-steps" role="tablist" aria-label="Sections">
        {steps.map((s, i) => (
          <button
            type="button"
            role="tab"
            key={s.key}
            aria-selected={activeKey === s.key}
            className={`cf-step-tab${isDone(s) ? ' done' : ''}`}
            onClick={() => onStep(s.key)}
          >
            <span className="cf-step">
              <span className="n">{i + 1}</span>
              <FiCheck className="chk" size={16} />
              {(s.count || 0) > 0 && <span className="cf-cnt">{s.count}</span>}
            </span>
            <span className="cf-steplbl">{s.label}</span>
          </button>
        ))}
      </div>
      <div className="cf-stephint">
        <span>Step <b>{idx + 1}</b> of {steps.length} · <b>{steps[idx]?.label}</b> · steps can be opened in any order</span>
        <span className="cf-stepmeter"><span>{filled} of {steps.length} sections visited</span><span className="cf-meter"><i style={{ width: `${Math.round((filled / steps.length) * 100)}%` }} /></span></span>
      </div>

      <div className="cf-pop-body">{children}</div>

      <div className="cf-pop-foot">
        <span className="cf-foot-hint"><span className="cf-req">*</span> Required fields. Next and Previous are only shortcuts.</span>
        <div className="cf-headbtns">
          <button type="button" className="cf-btn cf-btn-ghost" disabled={idx === 0} onClick={() => onStep(steps[idx - 1].key)}>Previous</button>
          <button type="button" className="cf-btn cf-btn-ghost" disabled={idx === steps.length - 1} onClick={() => onStep(steps[idx + 1].key)}>Next</button>
        </div>
      </div>
    </div>
  );
};

export default StepForm;
